import type { Freshness, SourceKind } from './primitives.js'

export const FRESH_MAX_DAYS = 7
export const STALE_MAX_DAYS = 30

const MS_PER_DAY = 24 * 60 * 60 * 1000

export interface FreshnessInput {
  source: SourceKind
  updatedAt: string | null
  now: Date
}

/**
 * Un dato de adapter con sync se considera fresco: si el sync se rompió,
 * eso se reporta como fuente en error, no como dato viejo.
 * La carga manual sí envejece, y a los 30 días genera alerta.
 */
export function evaluateFreshness({
  source,
  updatedAt,
  now,
}: FreshnessInput): Freshness {
  if (updatedAt === null) return 'expired'
  if (source !== 'manual') return 'fresh'

  const days = (now.getTime() - new Date(updatedAt).getTime()) / MS_PER_DAY
  if (days <= FRESH_MAX_DAYS) return 'fresh'
  if (days <= STALE_MAX_DAYS) return 'stale'
  return 'expired'
}
